

































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import AuthService from "../services/auth-service";
import VideoLearning from "../components/VideoLearning.vue";
import VideoLearningSmart from "../components/VideoLearningSmart.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import VideoQuiz from "../components/VideoQuiz.vue";

import "@/styles/Videos.scss";
import * as franc from "franc";

@Component({
  components: {
    "video-learning": VideoLearning,
    "video-learning-smart": VideoLearningSmart,
    swiper,
    "video-quiz": VideoQuiz,
    swiperSlide,
  },
})
export default class VideosTopic extends Vue {
  private service = new GeneralService();
  private items: GActivity[] = [];
  private chapters: GActivity[] = [];
  private isChapter = false;
  private isTopic = false;
  private attempted: number = 0;
  private noContent = false;
  private level_id;
  private isVideoQuiz = false;
  private topicid = "";
  private topicname = "";
  private checkTopic = false;
  private watching = 0;
  private mcqlimit = 10000;
  private chapterlimit = 10000;
  private topiclimit = 10000;
  private filter = "";
  private modalShow = false;
  private isSmart = false;
  private selectedTopics: any = [];
  private selectedTopic: any = "";
  private selectedChapter: any = "";
  private videoKey = 0;
  public contentIds: any = '';
  public IsArvo: boolean = false;
  public refferenceValue: string = '';
  private chapterId = '';

  private auth = new AuthService();
  private fields = ["index", { key: "fullName", label: "Chapter Name" }];

  get itemsWithIndex() {
    return this.items.map((item, i) => ({ ...item, _rowIndex: i + 1 }));
  }

  filterWithIndex(row: any, filter: string) {
    const f = filter.toLowerCase();
    const rowNum = String(row._rowIndex);
    const name = (row.fullName || '').toLowerCase();
    return rowNum.includes(f) || name.includes(f);
  }

  private checkLang(str) {
    var lst = ["und", "urd", "fas", "pes", "skr", "arb", "uig"];
    var lan = franc(str, { minLength: 3 });

    return lst.indexOf(lan) > -1;
  }

  stripHtml(html: string): string {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  private slidePrev(x) {
    (this.$refs[x] as any)[0].swiper.slidePrev();
  }

  private slideNext(x) {
    (this.$refs[x] as any)[0].swiper.slideNext();
  }

  private quizClicked(event, item) {
    event.stopPropagation();
    this.topicid = item.id;
    this.topicname = item.fullName;
    this.isVideoQuiz = true;
  }

  private swiperOption = {
    slidesPerView: 3,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      // when window width is <= 640px
      640: {
        slidesPerView: 1,
      },
      1000: {
        slidesPerView: 2,
      },
    },
  };

  private topicChangeParent(value) {
    this.getTopicsSmart(
      value.topic,
      value.id,
      value.name,
      value.topics,
      value.chaptername
    );
    this.videoKey++;
  }

  getTopicsSmart(topic, id, name, topics, chapter) {
    window.scrollTo(0, 0);
    this.isTopic = true;
    this.isChapter = false;
    this.$store.state.topicSelectName = name;
    this.$store.state.topicSelectId = id;
    this.selectedTopics = topics;
    this.selectedTopic = topic;
    this.selectedChapter = chapter;
  }

  private getTopics(id, name, index, data?) {
    window.scrollTo(0, 0);
    if (this.isSmart) {
      this.isChapter = true;
    }
    this.filter = "";
    if (this.isChapter) {
      if (index >= this.topiclimit) {
        this.modalShow = true;
        return;
      }
      // Topic clicked — launch video player
      // The topic item from GetARVOContentWeb has topicId as the video identifier
      const topicId = (data && data.item && data.item.topicId) ? data.item.topicId : id;
      this.isTopic = true;
      this.isChapter = false;
      this.$store.state.topicSelectName = name;
      this.$store.state.topicSelectId = topicId;
    } else {
      if (index >= this.chapterlimit) {
        this.modalShow = true;
        return;
      }
      this.chapterId = id;
      this.isChapter = true;
      localStorage["VcId"] = id;
      (this.$refs.btable as any).fields[1].label = "Topic Name";
      const item = { key: "progress", label: "Watched" };
      (this.$refs.btable as any).fields.splice(2, 0, item);

      this.$store.state.chapterSelectName = name;
      this.$store.state.chapterSelectId = id;
      if (!this.isSmart) {
        // Extract contentIds and referenceValue from chapter item and store for later use
        if (data && data.item) {
          if (data.item.content && data.item.content[0] && data.item.content[0].contentIds) {
            this.contentIds = data.item.content[0].contentIds;
          } else if (data.item.contentIds) {
            this.contentIds = data.item.contentIds;
          }
          if (data.item.referenceValue) {
            this.refferenceValue = data.item.referenceValue;
          }
        }
        const val = 'HADAF?' + this.contentIds + '?Videos??' + this.refferenceValue +
          '?' + id + '?' + this.auth.session.userId + '?' + this.IsArvo + '?false';
        this.service
          .getQuestionsWAnswersArvo(val)
          .then((result) => {
             if (result == 'There are no Questions for this Topic.' || result.length == 0) {
                  this.noContent = true;
                     this.items = [];
                  console.log('result.data', result)
                  return;

                }
            if (!result || result.length === 0) {
              this.items = [];
              this.noContent = true;
              return;
            }
             
            this.noContent = false;
            // Strip HTML from fullName for clean display
            for (let item of result) {
              if (item.fullName) { item.fullName = this.stripHtml(item.fullName); }
            }
            this.items = result;
            this.watching = 0;
            var watched = 0;
            for (var item of this.items) { watched += item.maxWatched; }
            this.watching = Math.round((watched / (this.items.length * 100)) * 100);
          })
          .catch((err) => { console.error(`Error: ${err.message}`); });
      } else {
        const programSelectString = localStorage[config.programSelect];
        const programSelectData = JSON.parse(programSelectString);
        const boardId = programSelectData.board.endsWith('s')
          ? programSelectData.board.slice(0, -1) : programSelectData.board;
        const classId = programSelectData.part;
        if (data && data.item) {
          if (data.item.content && data.item.content[0] && data.item.content[0].contentIds) {
            this.contentIds = data.item.content[0].contentIds;
          } else if (data.item.contentIds) {
            this.contentIds = data.item.contentIds;
          }
          if (data.item.referenceValue) {
            this.refferenceValue = data.item.referenceValue;
          }
        }
        const val = this.auth.session.userId + '?' + this.level_id + '?' + boardId +
          '?' + this.$store.state.selectSubjectName + '?' + classId + '?' + id +
          '?' + this.contentIds + '?' + this.refferenceValue;
        this.service
          .getarvosmartVideoContent2(val)
          .then((result) => {
            if (!result || result.length === 0) {
              this.items = [];
              this.noContent = true;
              return;
            }
            this.noContent = false;
            for (let item of result) {
              if (item.fullName) { item.fullName = this.stripHtml(item.fullName); }
            }
            this.items = result;
            this.watching = 0;
            var watched = 0;
            for (var item of this.items) { watched += item.maxWatched; }
            this.watching = Math.round((watched / (this.items.length * 100)) * 100);
          })
          .catch((err) => { console.error(`Error: ${err.message}`); });
      }
    }
  }

  reset(evt) {
    if (evt == "chapter") {
      this.isTopic = false;
      if (!this.isSmart) {
        // Use stored contentIds and referenceValue
        const val = 'HADAF?' + this.contentIds + '?Videos??' + this.refferenceValue +
          '?' + this.chapterId + '?' + this.auth.session.userId + '?' + this.IsArvo + '?false';
        this.service
          .getQuestionsWAnswersArvo(val)
          .then((result) => {

             if (result == 'There are no Questions for this Topic.' || result.length == 0) {
                  this.noContent = true;
                     this.items = [];
                      this.isChapter = true;
                      this.isVideoQuiz = false;
                  console.log('result.data', result)
                  return;

                }
            if (!result || result.length === 0) {
              this.items = [];
              this.noContent = true;
              this.isChapter = true;
              this.isVideoQuiz = false;
              return;
            }
            this.noContent = false;
            for (let item of result) {
              if (item.fullName) { item.fullName = this.stripHtml(item.fullName); }
            }
            this.items = result;
            this.watching = 0;
            this.isChapter = true;
            this.isVideoQuiz = false;
            var watched = 0;
            for (var item of this.items) { watched += item.maxWatched; }
            this.watching = Math.round((watched / (this.items.length * 100)) * 100);
          })
          .catch((err) => { console.error(`Error: ${err.message}`); });
      }
    }

    if (evt == "subject") {
      this.isTopic = false;
      this.isChapter = false;
      this.noContent = false;
      this.items = this.chapters;
      this.$nextTick(() => {
        if (this.$refs.btable) {
          const fields = (this.$refs.btable as any).fields;
          // Remove extra columns (progress) if they were added
          if (fields.length > 2) { fields.splice(2, fields.length - 2); }
          fields[1].label = "Chapter Name";
        }
      });
    }
  }

  beforeRouteLeave(to, from, next) {
    const answer = window.confirm(
      "Do you really want to leave? you have unsaved changes!"
    );
    if (answer) {
      next();
    } else {
      next(false);
    }
  }

  created() {
    this.level_id = localStorage[config.classLevl];
    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      router.push("select");
    }

    if (this.$route.query.type && this.$route.query.type == "smart") {
      this.isSmart = true;
    }

    if (
      this.$store.state.selectSubject == "" ||
      this.$store.state.selectSubject == undefined ||
      this.$store.state.selectSubject == "null"
    ) {
      router.push("videosubject");
    }

    if (this.auth.session.userName === "facebook@pgc.edu") {
      let fbjson = localStorage[config.fbLogin];
      let userinformation;
      if (fbjson !== undefined && fbjson !== "error") {
        userinformation = JSON.parse(localStorage[config.fbLogin]);

        let temp_str =
          this.auth.session.userId +
          ":" +
          userinformation.id +
          ":" +
          userinformation.name +
          ":" +
          userinformation.email;

        this.service.processFb(temp_str).then((result) => {
          this.mcqlimit = result[0].mcQs;
          this.chapterlimit = result[0].chapters;
          this.topiclimit = result[0].topics;
        });
      } else {
        this.auth.logout();
      }
    } else if (!this.isSmart) {
      // Student info is cached in store — no need to call getInfoEMS
    }

    if (this.$route.params.videoSelected == "true") {
      this.isTopic = true;
    }

    if (this.isSmart) {
      const programSelectString = localStorage[config.programSelect];
      const programSelectData = JSON.parse(programSelectString);
      const boardId = programSelectData.board.endsWith('s')
        ? programSelectData.board.slice(0, -1)
        : programSelectData.board;
      const classId = programSelectData.part;
      const val = this.auth.session.userId + '?' + this.$store.state.selectSubject +
        '?' + boardId + '?' + this.$store.state.selectSubjectName + '?' + classId;
      this.service
        .getarvosmartChapters(val)
        .then((result) => {
          if (!result || result.length === 0) { return; }
          this.items = result;
          this.chapters = result;
          this.items.forEach(value => {
            value.fullName = value.fullName.replace(/^\d+[.)]\s*/, '');
          });
          if (this.items.findIndex((e) => e.fullName == 'Promo') > -1) {
            this.items.splice(this.items.findIndex((e) => e.fullName == 'Promo'), 1);
          }
        })
        .catch((err) => { console.error(`Error: ${err.message}`); });
    } else {
      // New Videos (ARVO) path
      const programSelectString = localStorage[config.programSelect];
      const programSelectData = JSON.parse(programSelectString);
      const boardId = programSelectData.board.endsWith('s')
        ? programSelectData.board.slice(0, -1)
        : programSelectData.board;
      const classId = programSelectData.part.replace(/\s+/g, '');
      let programnaem: any;
      if (this.auth.session.varification == '-1' || this.auth.session.varification == '0' || this.auth.session.varification == '1') {
        programnaem = programSelectData.name;
      } else {
        programnaem = this.auth.session.varification;
      }
      const val = boardId + '?' + classId + '?HADAF?Videos?false?' +
        this.auth.session.userId + '?' + this.$store.state.selectSubject +
        '?' + this.$store.state.selectSubjectName;

      if (this.$route.query.type && this.$route.query.type == 'Old') {
        // Old Videos path
        const oldVal = this.auth.session.userId + '?' + this.$store.state.selectSubject;
        this.service
          .mcqOldChapters(oldVal)
          .then((result) => {
            this.items = result;
            this.chapters = result;
            this.items.forEach(value => {
              value.fullName = value.fullName.replace(/^\d+[.)]\s*/, '');
            });
            if (this.items.findIndex((e) => e.fullName == 'Promo') > -1) {
              this.items.splice(this.items.findIndex((e) => e.fullName == 'Promo'), 1);
            }
          })
          .catch((err) => { console.error(`Error: ${err.message}`); });
      } else {
        // New Videos (ARVO) path
        this.service
          .mcqArvoChapters(val, programnaem)
          .then((result) => {
            this.items = result;
            this.chapters = result;
            if (result && result.length > 0) {
              this.IsArvo = (result[0] as any).isArvo || false;
            }
            this.items.forEach(value => {
              value.fullName = value.fullName.replace(/^\d+[.)]\s*/, '');
            });
            if (this.items.findIndex((e) => e.fullName == 'Promo') > -1) {
              this.items.splice(this.items.findIndex((e) => e.fullName == 'Promo'), 1);
            }
          })
          .catch((err) => { console.error(`Error: ${err.message}`); });
      }
    }
  }
}
